import React, { Component } from "react";
import SideNav from "../SideNav/SideNav";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import actions from "actions";
import {
  getSignedinState,
  getPasswordChange,
  getGroups,
  getCurrentPage,
  getMenu,
  getSigninClear,
  getClinicianWorkflowStatus,
  getUserClinicianId,
  getCurrentClinicianId,
  isClinician,
  isCaregiver,
  isLegacyUser,
  isSubscribed,
  workflowStatus,
  getLogin,
  getUserPermissionsList,
  getUserId,
  getUser,
  getClientId,
  getBuildVersionCode,
} from "../../selectors";
import RefreshPageDialog from "./RefreshPageDialog";
import { HeaderMobile } from "./HeaderMobile";
import { Header } from "./Header";
import Box from "@mui/material/Box";

const mapStateToProps = (state) => ({
  signedInState: getSignedinState(state),
  passwordChange: getPasswordChange(state),
  groups: getGroups(state),
  menu: getMenu(state),
  currentPage: getCurrentPage(state),
  clear: getSigninClear(state),
  clinicianWorkflowStatus: getClinicianWorkflowStatus(state),
  clinicianId: getCurrentClinicianId(state),
  userClinicianId: getUserClinicianId(state),
  isClinician: isClinician(state),
  isCaregiver: isCaregiver(state),
  userId: getUserId(state),
  subscribed: isSubscribed(state),
  isLegacyUser: isLegacyUser(state),
  workflowStatus: workflowStatus(state),
  user: getUser(state),
  login: getLogin(state),
  userPermissions: getUserPermissionsList(state),
  versionCode: getBuildVersionCode(state),
  clientId: getClientId(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signOut: actions.signOut,
      checkAuthState: actions.checkAuthState,
      clearBasicDetails: actions.clearBasicDetails,
      clearCustomerSearch: actions.clearCustomerSearch,
      getBuildVersion: actions.getBuildVersion,
      setWeekStartDate: actions.setWeekStartDate,
      setWeekEndDate: actions.setWeekEndDate,
    },
    dispatch
  );

class HeaderContainer extends Component {
  state = {
    drawerOpen: false,
    displayHeader: true,
    refreshPageOpen: false,
    checkAuthState: true,
  };

  componentDidMount() {
    if (
      (this.props.location &&
        (this.props.location.pathname === "/force-password-change" ||
          this.props.location.pathname === "/reset-password" ||
          this.props.location.pathname === "/account-selection" ||
          this.props.location.pathname.includes("/setup/") ||
          this.props.location.pathname.includes("/accept-invitation/") ||
          this.props.location.pathname === "/test")) ||
      this.props.location.pathname.includes("/static-video-page") ||
      this.props.location.pathname.includes("/video/") ||
      this.props.location.pathname.includes("/rescheduling-session") ||
      this.props.location.pathname.includes("/document-viewer/")
    ) {
      let checkAuthState = true;
      if (this.props.location.pathname.includes("/static-video-page")) {
        checkAuthState = false;
      }
      this.setState({ displayHeader: false, checkAuthState });
    } else {
      this.checkAccess(this.props);
      this.setState({ displayHeader: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentPage !== prevProps.currentPage) {
      this.checkAccess(this.props);
    }
    if (!prevProps.userPermissions && this.props.userPermissions) {
      this.checkAccess(this.props);
    }
    if (!prevProps.signedInState && this.props.signedInState) {
      this.props.getBuildVersion();
    }
    if (
      (!prevProps.versionCode && this.props.versionCode) ||
      (prevProps.versionCode !== this.props.versionCode && this.props.versionCode)
    ) {
      this.checkVersionCode();
    }
    if (
      (prevProps.signedInState && !this.props.signedInState) ||
      (prevProps.signedInState === null && this.props.signedInState === false)
    ) {
      if (this.props.clear) {
        this.props.history.replace("/");
        return;
      }
    }

    if (
      prevProps.location &&
      (prevProps.location.pathname.indexOf("get-started") >= 0 ||
        prevProps.location.pathname.indexOf("/referral") >= 0)
    ) {
      return false;
    }

    if (prevProps.location && prevProps.location.pathname !== this.props.location.pathname) {
      if (
        this.props.location.pathname !== "/" &&
        this.props.location.pathname !== "/force-password-change" &&
        this.props.location.pathname !== "/reset-password" &&
        this.props.location.pathname !== "/account-selection" &&
        !this.props.location.pathname.includes("/rescheduling-session") &&
        !this.props.location.pathname.includes("/setup/") &&
        !this.props.location.pathname.includes("/accept-invitation/") &&
        !this.props.location.pathname.includes("/static-video-page") &&
        !this.props.location.pathname.includes("/video/") &&
        !this.props.location.pathname.includes("/document-viewer/")
      ) {
        this.setState({ displayHeader: true });
      } else {
        this.setState({ displayHeader: false });
      }
    }

    if (prevProps.groups.length === 0 && this.props.groups.length > 0) {
      this.checkAccess(this.props);
    }

    if (
      (prevProps.location?.pathname?.includes("/video-calls/") ||
        prevProps.location?.pathname == "/upcoming-video-calls" ||
        prevProps.location?.pathname == "/clinician-schedule") &&
      !this.props.location?.pathname?.includes("/video-calls/") &&
      this.props.location?.pathname !== "/upcoming-video-calls" &&
      this.props.location?.pathname !== "/clinician-schedule"
    ) {
      this.props.setWeekStartDate("");
      this.props.setWeekEndDate("");
    }
  }

  componentWillUnmount() {
    localStorage.removeItem("currentAudioInput");
    localStorage.removeItem("currentAudioOutput");
    localStorage.removeItem("currentCameraInput");
  }

  checkAccess(props) {
    if (this.state.checkAuthState) {
      this.props.checkAuthState();
    }
    if (props.currentPage === "404") {
      return;
    }
  }

  checkVersionCode = () => {
    const { versionCode } = this.props;
    if (
      versionCode &&
      // eslint-disable-next-line no-undef
      versionCode != APP_VERSION.split("-")[0] &&
      process.env.NODE_ENV === "production"
    ) {
      this.setState({ refreshPageOpen: true });
    }
  };

  onClickRefreshPage = () => {
    window.location.reload(window.location.href + "?r=t");
  };

  navigateMobile = (routeName) => {
    this.handleDrawerToggle();
    this.props.history.push(routeName);
  };

  logout = () => {
    this.props.signOut(true);
  };

  handleMenuClicked = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };

  handleSearchChange = (e, value, allUsers, teamMemberValue) => {
    let clientId;

    if (value?.clientId) {
      clientId = value.clientId;
    } else if (value?.children && value.children.length > 0) {
      clientId = value.children[0]?.clientId;
    }

    if (allUsers) {
      this.props.history.replace(`/users/${value.id}`);
    } else if (clientId || value?.members) {
      if (teamMemberValue) {
        this.props.history.replace(
          `/clients/${clientId ?? value?.members[0].clientId}/profile?teamMember=${teamMemberValue}`
        );
      } else {
        this.props.history.replace(`/clients/${clientId}/dashboard`);
      }
    } else if (value?.clinicianId) {
      let activateGo = this.props.location?.pathname?.includes(`/clinicians/`);
      this.props.history.replace(`/clinicians/${value.clinicianId}/dashboard`);
      if (activateGo) {
        this.props.history.go();
      }
    }
  };

  handleDrawerToggle = () => {
    this.setState((state) => ({ drawerOpen: !state.drawerOpen }));
  };

  hideDrawer = () => {
    this.setState({ drawerOpen: false });
  };

  render() {
    const { user, userPermissions } = this.props;
    if (!this.props.signedInState) {
      return <React.Fragment />;
    }
    const userFullName = user?.first_name ? `${user.first_name} ${user.last_name}` : "";
    const userInitials = user?.first_name
      ? `${user.first_name[0].toUpperCase()}${user.last_name[0].toUpperCase()}`
      : "";
    return (
      <>
        {this.state.displayHeader && (
          <>
            <Box sx={{ display: { xs: "none", lg: "block" }, padding: "16px 24px 0px 24px" }}>
              <Header
                handleMenuClicked={this.handleMenuClicked}
                logout={this.logout}
                menuExpanded={this.state.menuOpen}
                userFullName={userFullName}
                userInitials={userInitials}
                userAvatarSrc={user?.image_url || null}
                handleSearchChange={this.handleSearchChange}
                userPermissions={userPermissions}
              />
            </Box>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                top: 0,
                left: 0,
                display: { md: "flex", lg: "none" },
              }}
            >
              <HeaderMobile
                handleMenuClicked={this.handleMenuClicked}
                logout={this.logout}
                menuExpanded={this.state.menuOpen}
                userInitials={userInitials}
                userAvatarSrc={user?.image_url || null}
                handleDrawerToggle={this.handleDrawerToggle}
                userPermissions={userPermissions}
              />
              <SideNav
                {...this.state}
                {...this.props}
                navigate={this.navigateMobile}
                handleDrawerToggle={this.handleDrawerToggle}
                hideDrawer={this.hideDrawer}
                mobile={true}
              />
            </Box>
          </>
        )}
        <RefreshPageDialog
          open={this.state.refreshPageOpen}
          onClickRefreshPage={this.onClickRefreshPage}
        />
      </>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderContainer));
